/*@flow*/
import type {
  Metric,
  MapConfig,
  MapConfig$Analysis,
  MapConfig$Dataview,
  Metric$Analysis,
} from './types';

const getUniq = (
  v: {
    id: string,
    type: 'source',
    params: { query: string },
  }[]
) => {
  const ids = v.map((v2) => v2.id);
  return v.filter((v2, i) => ids[i] === v2.id);
};

const mapToId = (m, dp) => {
  const ids = dp.map((v, i) => v.id || i);
  return m.reduce((s, v, i) => {
    const id = 'c-' + ids[i];
    return { ...s, [id]: v };
  }, {});
};

export default function getMapConfig(
  placeMetrics: Metric[]
): $Exact<MapConfig> {
  let cartoAnalyses = [];
  let dataviews = [];

  const CartoAnalysis = (v: Metric$Analysis): MapConfig$Analysis => {
    return {
      id: v.id,
      type: 'source',
      params: { query: v.sql },
    };
  };

  const CartoDataview = (v): MapConfig$Dataview => {
    return {
      type: 'formula',
      source: { id: v.analysis.id },
      options: {
        column: v.dataview.column,
        operation: v.dataview.operation,
      },
    };
  };

  placeMetrics.forEach((v) => {
    cartoAnalyses = cartoAnalyses.concat(CartoAnalysis(v.analysis));
    dataviews = dataviews.concat(CartoDataview(v));
  });

  const version = '1.4.0';

  cartoAnalyses = getUniq(cartoAnalyses);

  return {
    version,
    analyses: cartoAnalyses,
    layers: [],
    dataviews: mapToId(dataviews, placeMetrics),
  };
}
